export default __webpack_public_path__ + "static/media/companyPitch.1ba4a59f.svg";